import React, {
    useEffect,
    useState,
} from "react";

import {
    Box,
    Flex,
    Text,
} from "@chakra-ui/react";

import { useDispatch, useSelector } from "react-redux";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import ReusableTable from "components/Tables/ReusableTable";
import GradientButton from "components/Buttons/GradientButton";
import StatusBadge from "components/Badges/StatusBadge";

import { formatDate } from "utils/dateFormatter";

import { fetchWalletTransactionsAction } from "state/actions/walletTransactionActions";

const PAGE_SIZE = 10;

const WalletTransactions = () => {
    const dispatch = useDispatch();

    const [currentPage, setCurrentPage] =
        useState(1);

    const {
        walletTransactions,
        loading,
    } = useSelector(
        (state) => state.walletTransactions
    );

    useEffect(() => {
        dispatch(
            fetchWalletTransactionsAction(
                currentPage,
                PAGE_SIZE
            )
        );
    }, [
        dispatch,
        currentPage,
    ]);

    const getTransactionVariant = (
        type
    ) => {
        switch (type) {
            case "TOP_UP":
                return "success";

            case "ADMIN_TOP_UP":
                return "info";

            case "COMMISSION":
                return "warning";

            case "DELIVERY_DEDUCTION":
                return "danger";

            case "REFUND":
                return "purple";

            case "ADJUSTMENT":
                return "blue";

            default:
                return "gray";
        }
    };

    const columnsData = [
        {
            Header: "Driver",
            accessor: (
                row
            ) =>
                `${row.user_info.first_name} ${row.user_info.last_name}`,
        },
        {
            Header: "Transaction",
            accessor: (
                row
            ) =>
                row.transaction
                    .transaction_type,

            Cell: ({
                value,
            }) => (
                <StatusBadge
                   label={value
                        .toLowerCase()
                        .replaceAll("_", " ")
                        .replace(/\b\w/g, (char) =>
                            char.toUpperCase()
                        )}
                    variant={getTransactionVariant(
                        value
                    )}
                />
            ),
        },
        {
            Header: "Amount",
            accessor: (
                row
            ) =>
                `P${Number(
                    row.transaction.amount
                ).toFixed(2)}`,
        },
        {
            Header:
                "Balance Before",
            accessor: (
                row
            ) =>
                `P${Number(
                    row.transaction
                        .balance_before
                ).toFixed(2)}`,
        },
        {
            Header:
                "Balance After",
            accessor: (
                row
            ) =>
                `P${Number(
                    row.transaction
                        .balance_after
                ).toFixed(2)}`,
        },
        {
            Header:
                "Description",
            accessor: (
                row
            ) =>
                row.transaction
                    .description ||
                "-",
        },
        {
            Header:
                "Reference",
            accessor: (
                row
            ) =>
                row.transaction
                    .reference ||
                "-",
        },
        {
            Header: "Created",
            accessor: (
                row
            ) =>
                row.transaction
                    .created_at,

            Cell: ({
                value,
            }) =>
                formatDate(
                    value
                ),
        },
    ];

    return (
        <Flex
            flexDirection="column"
            pt={{
                base: "120px",
                md: "75px",
            }}
        >
            <Box p={6}>
                <Text
                    fontSize="md"
                    fontWeight="bold"
                >
                    {loading ? (
                        <Skeleton width="180px" />
                    ) : (
                        `Wallet Transactions: ${
                            walletTransactions?.total ??
                            0
                        }`
                    )}
                </Text>
            </Box>

            <ReusableTable
                columnsData={
                    columnsData
                }
                tableData={
                    Array.isArray(
                        walletTransactions?.data
                    )
                        ? walletTransactions.data
                        : []
                }
                isLoading={
                    loading
                }
            />

           <Flex
    justify="center"
    align="center"
    gap={4}
    mt={6}
>
    <GradientButton
        height="35px"
        fontSize="13px"
        onClick={() =>
            setCurrentPage((prev) =>
                Math.max(prev - 1, 1)
            )
        }
        disabled={currentPage === 1}
    >
        Previous
    </GradientButton>

    <Text
        fontSize="sm"
        color="gray.600"
        fontWeight="600"
        minW="100px"
        textAlign="center"
    >
        Page {walletTransactions?.page} of{" "}
        {walletTransactions?.pages}
    </Text>

    <GradientButton
        height="35px"
        fontSize="13px"
        onClick={() =>
            setCurrentPage((prev) => prev + 1)
        }
        disabled={
            currentPage >=
            (walletTransactions?.pages || 1)
        }
    >
        Next
    </GradientButton>
</Flex>
        </Flex>
    );
};

export default WalletTransactions;